// extracted by mini-css-extract-plugin
module.exports = {"table":"b1ddd01198--table--dQF8j","switch":"b1ddd01198--switch--akI8z","item":"b1ddd01198--item--EnSIl","visible":"b1ddd01198--visible--HuJ4r"};